import { render, staticRenderFns } from "./boletins.vue?vue&type=template&id=5f9aa094&scoped=true&"
import script from "./boletins.ts?vue&type=script&lang=ts&"
export * from "./boletins.ts?vue&type=script&lang=ts&"
import style0 from "./boletins.vue?vue&type=style&index=0&id=5f9aa094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9aa094",
  null
  
)

export default component.exports